// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actions_iconDisabled__eznFc path {
  fill: var(--mui-palette-grey-300);
}
`, "",{"version":3,"sources":["webpack://./src/components/most/list/history/item/suggested-tasks/columns/actions/index.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC","sourcesContent":[".iconDisabled path {\n  fill: var(--mui-palette-grey-300);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconDisabled": `actions_iconDisabled__eznFc`
};
export default ___CSS_LOADER_EXPORT___;
